import { Component, inject } from '@angular/core';
import { AuthService as AuthService } from '../../services/auth.service';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';
import { AuditLogService } from '../../../../shared/services/audit-log/audit-log.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent extends DestroyBase {
  authService = inject(AuthService);
  auditLogService = inject(AuditLogService);

  onLogout(): void {
    this.auditLogService.logFeature({
      featureName: 'logout',
      action: 'logout',
      meta: {},
      description: 'User logs out',
    });

    this.authService.logout().pipe(takeUntil(this.destroy$)).subscribe();
  }
}
